module.exports = __webpack_public_path__ + "static/media/IMG_5632.402fd57b.JPG";